import { FieldContainer } from '../functional'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import { useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'

interface Props extends DatePickerProps<any> {
   name: string
   highlight?: boolean
}

const DateField: React.FC<Props> = (props) => {
   const { name, label, highlight, ...rest } = props
   const fieldContainerRef = useRef<HTMLDivElement>(null)
   const popperComponentRef = useRef<HTMLDivElement>(null)
   const dialogComponentRef = useRef<HTMLDivElement>(null)

   return (
      <FieldContainer name={name} highlight={highlight}>
         {({ helperText, error, onBlur, ...fieldProps }) => {
            const [isOpen, setIsOpen] = useState(false)
            useEffect(() => {
               const handleClosePopper = (event: any) => {
                  if (!fieldContainerRef.current) return
                  const isClickedElementOutsideFieldContainer = !fieldContainerRef.current.contains(
                     event.target,
                  )
                  const isClickedElementOutsidePopperComponent =
                     !popperComponentRef.current?.contains(event.target)

                  isClickedElementOutsideFieldContainer &&
                     isClickedElementOutsidePopperComponent &&
                     setIsOpen(false)
               }
               document.addEventListener('click', handleClosePopper)

               return () => {
                  document.removeEventListener('click', handleClosePopper)
               }
            }, [])
            const handleBlur = () => {
               !isMobile
                  ? !isOpen && onBlur({ target: { name } })
                  : // We need to wait for the dialog animation to close before calling onBlur
                    setTimeout(() => onBlur({ target: { name } }), 10)
            }

            const popperProps = !isMobile
               ? {
                    open: isOpen,
                    disableOpenPicker: true,
                 }
               : {}

            return (
               <div ref={fieldContainerRef}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                     <DatePicker
                        {...rest}
                        {...fieldProps}
                        label={label}
                        value={fieldProps.value}
                        onChange={(value) => {
                           fieldProps.onChange({ target: { name, value } })
                        }}
                        onAccept={() => {
                           setIsOpen(false)
                        }}
                        slotProps={{
                           textField: {
                              ...(!isMobile ? { onClick: () => setIsOpen(true) } : {}),
                              helperText,
                              error,
                              fullWidth: true,
                              onBlur: () => !isMobile && handleBlur(),
                           },

                           popper: {
                              container: document.querySelector('dialog') || undefined,
                              ref: popperComponentRef,
                           },
                           dialog: {
                              container: document.querySelector('dialog') || undefined,
                              ref: dialogComponentRef,
                              onBlur: handleBlur,
                           },
                        }}
                        closeOnSelect
                        name={name}
                        {...popperProps}
                     />
                  </LocalizationProvider>
               </div>
            )
         }}
      </FieldContainer>
   )
}

export default DateField
